export default __webpack_public_path__ + "static/media/expl_15_EN.0f6aa1ce.png";